import { Box } from '@mui/material';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

import { useArticleCardContext } from '../article-card';

export const ArticleCardContentContentInfo = (): ReactElement | null => {
    const { article } = useArticleCardContext();
    const { contentQuantity, contentUnit, currentSpecialPrice, mainPrice, currency, priceQuantity, orderUnit } =
        article;

    const price = currentSpecialPrice || mainPrice;

    return (
        <PoolTypography variant="caption" color="grey.800">
            <Box>
                <FormattedMessage
                    id="app.article.priceQuantity"
                    values={{
                        priceQuantity: priceQuantity > 1 ? <FormattedNumber value={priceQuantity} /> : null,
                        unit: orderUnit,
                        price: (
                            <FormattedNumber
                                value={price}
                                currency={currency}
                                style="currency"
                                minimumFractionDigits={2}
                                maximumFractionDigits={4}
                            />
                        ),
                        optional: chunks => priceQuantity > 1 && chunks,
                    }}
                />
            </Box>
            {!!contentQuantity && (
                <Box>
                    <FormattedMessage
                        id="app.article.contentQuantity"
                        values={{
                            contentQuantity: contentQuantity,
                            contentUnit: contentUnit,
                            orderUnit: orderUnit,
                            price: (
                                <FormattedNumber
                                    value={(currentSpecialPrice || mainPrice) / contentQuantity}
                                    currency={currency}
                                    style="currency"
                                    minimumFractionDigits={2}
                                    maximumFractionDigits={4}
                                />
                            ),
                            optional: chunks => contentQuantity > 1 && chunks,
                        }}
                    />
                </Box>
            )}
        </PoolTypography>
    );
};
